module.exports = __webpack_public_path__ + "img/wallet-payment.d6dca530.svg";